export default __webpack_public_path__ + "static/media/totem.bc3663a0.jpg";